import { memo } from 'react';

import { ComponentContextProps } from '@/components';
import { Logo, LogoProps } from '@/components/core';
import { EmailFilledIcon } from '@/components/icons';

export type EmailLogoProps = LogoProps & Partial<ComponentContextProps>;

const IEmailLogo = ({ className, ...rest }: EmailLogoProps) => {
  return (
    <Logo className={className} {...rest}>
      <EmailFilledIcon className="!text-teal-700" />
    </Logo>
  );
};

export const EmailLogo = memo(IEmailLogo) as typeof IEmailLogo;
